import React, { useEffect, useState, useContext } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { Link, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import "./Login.css";
import { useMediaQuery, useTheme } from "@mui/material";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthLeft from "./AuthLeft";
import { AuthContext, useAuth } from "../../context/AuthContext";
import { SendOtp } from "../../services/auth";
import api from "../../utils/axiosInstance";
import { getUserDetails } from "../../services/User";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  // border: '2px solid #000',
  boxShadow: 24,
  borderRadius: "10px",
  outline: "none",
  "@media(max-width:767.98px)": {
    width: "75%",
  },
  p: 4,
};

export default function Login() {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  // const { login } = useAuth();

  //   const path = usercalls();
  // const [email, setEmail] = useState();
  // const [password, setPassword] = useState();
  const [load, setLoad] = useState(false);
  const [verifyLoad, setVerifyLoad] = useState(false);

  const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{6,}$/;
  const regex = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;

  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const [allUsers, setAllUsers] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [verify, setVerify] = useState(false);

  const [verifyLoading, setVerifyLoading] = useState(false);

  
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setAllUsers({ ...allUsers, [name]: value });
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
        // errorMessage = "Email is required";
        // isValid = false;
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }

    // Handle password validation
    // if (fieldName === "password") {
    //   if (value === "" || value === undefined) {
    //     // errorMessage = "Password is required";
    //     // isValid = false;
    //   } else if (!passwordRegex.test(value)) {
    //     errorMessage =
    //       "Password must contain at least 6 characters, one uppercase letter, one special character, and one number";
    //     isValid = false;
    //   }
    // }

    // Set errors after validation
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!allUsers.email) {
      formErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(allUsers.email)) {
      formErrors.email = "Email is invalid";
      isValid = false;
    }

    // Validate password
    if (!allUsers.password) {
      formErrors.password = "Password is required";
      isValid = false;
    } 
    // else if (allUsers.password.length < 6) {
    //   formErrors.password = "Password must be at least 6 characters long";
    //   isValid = false;
    // } else if (!/^[A-Z]/.test(allUsers.password)) {
    //   formErrors.password = "Password must start with a capital letter";
    //   isValid = false;
    // }

    setErrors(formErrors);
    return isValid;
  };

  const handleSendOtp = async (e) => {
    // setLoad(true);
    setVerifyLoad(true);
    const data = {
      type: "email",
      email: allUsers.email,
    };
    const response = await SendOtp(data);

    if (response?.data?.success === true) {
    
      toast.success(response?.data?.message);
      setVerifyLoading(true);
      setTimeout(() => {
        navigate("/accountverify", {
          state: { email: allUsers.email },
        });
      }, 800);
      setVerifyLoad(true);
      // setTimeout(() => {
      //   navigate("/success", {
      //     state: { forgot: true, email: allUsers.email },
      //   });
      // }, 1500);
    } else {
      toast.error(response?.data?.message);
      setVerifyLoad(false);
      setVerifyLoading(false);
   
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);
      setVerify(false);
      const response = await login(allUsers);
      if (response?.data?.success === true) {
        setLoad(false);
        if (response?.data?.result?.details?.AccountVerify === true) {
          toast.success("Login Successfully...!");
          getAllUserDetails();
          setTimeout(() => {
            navigate("/");
          }, 1000);
        }
      } else {
        if (response?.data?.result?.details?.AccountVerify === false) {
          setVerify(true);
          toast.error(response?.data?.message);
        } else {
          toast.error(response?.data?.message);
        }
        setLoad(false);
      }
    }
  };

   const getAllUserDetails = async () => {
      const response = await getUserDetails();
      if (response?.data?.success === true) {
    const data=response?.data?.result
        localStorage.setItem("UserDetails", JSON.stringify(data));
      } else {
      }
    };

  const login = async (data) => {
    try {
      const response = await api.post(`/login`, data, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      });
      const token = response.data?.result?.accessToken;
      const details = response?.data?.result?.details;
      localStorage.setItem("Token", token);
      localStorage.setItem("userName", details?.name);
   
      localStorage.setItem("UserDetails", JSON.stringify(details));
   
      return response;
    } catch (error) {
      return error;
    }
    // localStorage.setItem("authToken", token);
    // checkToken();
  };

  

  return (
    <>
      {/* <AuthHeader /> */}
      {/* <Loader/> */}
      <ToastContainer  
        autoClose={2000}
      />
      <div className="register">
        <Grid
          container
          component="main"
          spacing={2}
          sx={{ alignItems: "flex-start", pt: 0 }}
          className={!md ? "medium" : ""}
        >
          <Grid
            size={{ xs: 12, sm: 12, md: 12, lg: 6 }}
            sx={{ pt: 0 }}
            style={{ paddingTop: "0px" }}
          >
            <AuthLeft />
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
            <Grid
              container
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: md ? "600px" : "auto",
                margin: "0 auto",
                height: "100vh",
              }}
            >
              <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                <Box
                  sx={{
                    my: md && 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <h2 className="c-accout text-center">Login</h2>
                  <p> Please Enter Your Details</p>

                  <Box sx={{ width: md ? "100%" : "90%" }}>
                    <div className="input-common mt-20">
                      <label>Email:</label>
                      <TextField
                        fullWidth
                        id="fullWidth"
                        placeholder="Enter Your Email"
                        name="email"
                        value={allUsers.email}
                        onChange={(e) => handleChange(e)}
                        onFocus={(e) => validateFocus(e)}
                        onInput={validateFocus}
                        error={!!errors.email}
                        helperText={errors.email}
                      />
                      {/* {errors.email && (
                            <span className="error" style={{ color: "red" }}>
                              {errors.email}
                            </span>
                          )} */}
                    </div>

                    <div className="input-common mt-20">
                      <label>Password</label>
                      <FormControl
                        sx={{ mt: 1, width: "100%" }}
                        variant="outlined"
                      >
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showPassword ? "text" : "password"}
                          value={allUsers.password}
                          placeholder="********"
                          onChange={(e) => {
                            handleChange(e);
                          }}
                          onFocus={validateFocus}
                          onInput={validateFocus}
                          // error={!!errors.password}
                          // helperText={errors.password}
                          name="password"
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                className="eye-icon"
                                aria-label={
                                  showPassword
                                    ? "hide the password"
                                    : "display the password"
                                }
                                onClick={handleClickShowPassword}
                                edge="end"
                              >
                                {showPassword ? (
                                  <Visibility />
                                ) : (
                                  <VisibilityOff />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                      <span
                        style={{
                          color: "#d32f2f",
                          fontSize: 13,
                          fontWeight: "bold",
                        }}
                      >
                        {errors.password}
                      </span>{" "}
                      {/* This line ensures error message is shown */}
                      {/* {errors.password && (
                        <span className="error" style={{ color: "red" }}>
                          {errors.password}
                        </span>
                      )} */}
                    </div>

                    <div className="reg-forget mt-10 display-4">
                      {verify === true ? (
                        <div
                        
                        >
                          {/* {verifyLoading === false && " Verify Email"} */}
                          {(verifyLoading === false && verifyLoad===false) ?
                          <div onClick={()=> handleSendOtp() }>
                          <Link>Verify Account</Link>
                          </div>
                             :  <Link>Please Wait...</Link>
}
                        </div>
                      ) : (
                        <Link to="/forgot">Forgot Password?</Link>
                      )}
                    </div>

                    <div className="common-btn text-center">
                      {load ? (
                        <Button fullWidth sx={{ mt: 3, mb: 2 }}>
                          Processing...
                        </Button>
                      ) : (
                        <Button
                          type="submit"
                          fullWidth
                          sx={{ mt: 3, mb: 2 }}
                          onClick={handleSubmit}
                          // onClick={() => {
                          //   navigate("/");
                          // }}
                        >
                          Login
                        </Button>
                      )}
                    </div>
                    <div className="text-center accnt-sign mt-50">
                      <Link to="/register" variant="body2">
                        Don't have an account? <span>Sign Up</span>
                      </Link>
                    </div>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
